import i18next from 'i18next';

/**
 * The locale a date or a time is written in: the language the reader chose in the app (the EN/ES toggle), never the
 * browser's (polish pass, 2026-10-28: in Spanish the app still wrote "Oct 19, 2026", because every formatter passed
 * `undefined` or a hard-coded 'en-US'). Before i18n starts it is undefined, the browser's own, as before.
 */
export function appLocale(): string | undefined {
  return i18next.isInitialized ? (i18next.resolvedLanguage ?? i18next.language) : undefined;
}
